import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home";
import SearchPage from "./pages/SearchPage";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import getLPTheme from "./getLPTheme";
import Pricing from "./homePage/Pricing";
import SignUp from "./pages/SignUp";
import CheckOut from "./homePage/CheckOut";
import ContactUs from "./pages/ContactUs";
import NotFound from "./pages/NotFound";
import FeatureComingSoon from "./components/FeatureComingSoon";
import Privacy from "./pages/Privacy";
import TermsofService from "./pages/TermsofService";
import "./App.css";

function App() {
  const user = useSelector((state) => state.user.user);
  const mode = useSelector((state) => state.theme.mode);

  const LPtheme = createTheme(getLPTheme(mode));

  return (
    <BrowserRouter basename="/">
      <ThemeProvider theme={LPtheme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<HomePage user={user} />} />
          <Route path="/search/:newValue" element={<SearchPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="CheckOut" element={<CheckOut />} />
          <Route path="/auth" element={<SignUp />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-of-service" element={<TermsofService />} />
          <Route path="/coming-soon" element={<FeatureComingSoon />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
